import * as yup from "yup"
import { t } from "../../languages/i18n"

export const loginSchema = yup.object().shape({
  email: yup.string().email("Invalid email address").required(t("Please enter email!")),
  password: yup.string().required(t("Please enter password!")),
})
